import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <div className="d-flex">
      <Nav className="flex-column bg-light vh-100 p-3">
        <h3>Byket Box</h3>
        <Nav.Link
          as={Link}
          to="/products"
          className={isActive('/products') ? 'active text-primary' : ''}
        >
          Продукти
        </Nav.Link>
        <Nav.Link
          as={Link}
          to="/cells"
          className={isActive('/cells') ? 'active text-primary' : ''}
        >
          Комірки
        </Nav.Link>
        <Nav.Link
          as={Link}
          to="/bykets"
          className={isActive('/bykets') ? 'active text-primary' : ''}
        >
          Букети
        </Nav.Link>
      </Nav>
    </div>
  );
};

export default Navbar;
